import { ArrowRight } from "lucide-react";
import styles from "./AlertList.module.css";
import type { alertListProps } from "./types.props";

const AlertList: React.FC<alertListProps> = ({
    items,
    onItemClick,
    emptyMessage = "No hay alertas de este tipo.",
}) => {
    if (!items || items.length === 0) {
        return <p className={styles["no-alerts"]}>{emptyMessage}</p>;
    }

    return (
        <ul className={styles["alert-list"]}>
            {items.map((item) => (
                <li
                    key={item.id}
                    className={styles["alert-item"]}
                    onClick={() => onItemClick(item)}
                    onKeyDown={(e) =>
                        (e.key === "Enter" || e.key === " ") && onItemClick(item)
                    }
                    role="button"
                    tabIndex={0}
                >
                    <span className={styles["item-name"]}>
                        {item.primaryText}
                        {item.secondaryText && (
                            <span className={styles["secondary-text"]}>
                                ({item.secondaryText})
                            </span>
                        )}
                    </span>
                    <ArrowRight size={16} className={styles["arrow-icon"]} />
                </li>
            ))}
        </ul>
    );
};

export default AlertList;
